import React, { useState } from 'react';
import { Paper, Tab, Tabs } from '@material-ui/core';

import { CreateFeatureFlag } from 'components/product/components/createFeatureFlag';
import { UploadFeatureFlag } from 'components/product/components/uploadFeatureFlag';
import { UploadLineItem } from 'components/product/components/uploadLineItem';
import { ViewFeatureFlag } from 'components/product/components/viewFeatureFlag';
import { TabPanel } from 'shared';

function FeatureFlag() {
    const [selectedTab, setSelectedTab] = useState('0');
    const handleChange = (event, value) => {
        setSelectedTab(value);
    };

    return (
        <Paper>
            <Tabs onChange={handleChange} value={selectedTab} indicatorColor="primary" textColor="primary" centered>
                <Tab label="View Feature Flag" value="0" />
                <Tab label="Upload" value="1" />
                <Tab label="Create" value="2" />
                <Tab label="Line Item" value="3" />
            </Tabs>
            <TabPanel selectedTab={selectedTab} index="0">
                <ViewFeatureFlag />
            </TabPanel>
            <TabPanel selectedTab={selectedTab} index="1">
                <UploadFeatureFlag />
            </TabPanel>
            <TabPanel selectedTab={selectedTab} index="2">
                <CreateFeatureFlag />
            </TabPanel>
            <TabPanel selectedTab={selectedTab} index="3">
                <UploadLineItem />
            </TabPanel>
        </Paper>
    );
}

export { FeatureFlag };
